<template>
  <div class="card-hoverable card-hover-2  text-center p-3">
    
    <slot name="p-1"></slot>
    <slot name="p-2"></slot>
    <slot name="p-3"></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.card-hoverable {
  background-image: linear-gradient(to top, var(--light-secondary) 50%, transparent 50%);
  background-size: 100% 200%;
  background-position: top;
  transition: background-position 0.4s ease-in-out ;
  /** I've changed the time for demo purposes **/
  color: black;
  box-shadow: 6px 6px 12px var(--light-gray)  ;
  cursor: pointer;
  

}

.card-hover-2 {
  transition:  0.4s ease-in-out;
  border-radius: 15px;
}
.card-hover-2:hover {
  box-shadow: 3px 3px 6px var(--light-secondary)  ;
  transition:  0.4s ease-in-out;
  border-radius: 25px;
}

.card-hoverable:hover {
  background-position: bottom;
  
}
</style>